import { render, staticRenderFns } from "./EcommerceProductCategoryAttributeItem.vue?vue&type=template&id=82ef139c&lang=pug&"
import script from "./EcommerceProductCategoryAttributeItem.vue?vue&type=script&setup=true&lang=js&"
export * from "./EcommerceProductCategoryAttributeItem.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./EcommerceProductCategoryAttributeItem.vue?vue&type=style&index=0&id=82ef139c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports